import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useWhatsApp } from '../../hooks/useWhatsApp';
import { IconAlert } from '../icons';
import { Button } from '../Button';
interface ErrorStateProps {
  onRetry: () => void;
}

/** Recoverable submission failure: retry plus a direct WhatsApp route to a Queen. */
export function ErrorState({
  onRetry
}: ErrorStateProps) {
  const {
    t
  } = useLanguage();
  const whatsapp = useWhatsApp();
  return <div role="alert" className="border border-kred/60 bg-kred/10 p-5" data-id="element-275" data-mp="3ore8lgvhnab1">
      <div className="flex items-start gap-3" data-id="element-276" data-mp="3js1c04eteov9">
        <IconAlert className="mt-0.5 h-5 w-5 shrink-0 text-kred" data-id="element-277" data-mp="2i39bjgaoq50" />
        <p className="text-sm leading-relaxed text-white/85" data-id="element-278" data-mp="2g9ydrynfjr7">{t('form.err.submit')}</p>
      </div>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row" data-id="element-279" data-mp="3tqqu9yamibc1">
        <Button type="button" variant="solidLight" onClick={onRetry} className="sm:flex-1" data-id="element-280" data-mp="1dwgtad7xglfr">
          {t('form.retry')}
        </Button>
        <Button type="button" variant="whatsapp" onClick={() => whatsapp.open('form-error')} disabled={!whatsapp.available} className="sm:flex-1" data-id="element-281" data-mp="190jbs3kxh91e">
          {t('hero.ctaSecondary')}
        </Button>
      </div>
    </div>;
}